import {
  Module,
  VuexModule,
  Action,
} from 'vuex-module-decorators';

import {
  CORE_URL,
  SUPPORT_GET_USER,
  SUPPORT_EDIT_USER,
  SUPPORT_GET_BET,
  M_POST,
} from '@/utils/api';

import Vue from 'vue';

@Module({ name: 'user' })
export default class User extends VuexModule {
  @Action
  GetUser(params) {
    return Vue.axios({
      url: CORE_URL + SUPPORT_GET_USER,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  EditUser(params) {
    return Vue.axios({
      url: CORE_URL + SUPPORT_EDIT_USER,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }

  @Action
  GetBet(params) {
    return Vue.axios({
      url: CORE_URL + SUPPORT_GET_BET,
      data: params,
      method: M_POST,
    })
      .then(({ data }) => data)
      .catch((err) => err);
  }
}
